"use client";

import { Dialog } from "@headlessui/react";
import { XMarkIcon } from "@heroicons/react/24/outline";
import Link from "next/link";

import { LogoLink } from "@/components/LogoLink";
import { Badge } from "@/components/text/Badge";
import { navigationMarketing } from "@/constants/navigation";

export function MobileMenuDialog({
  mobileMenuOpen,
  setMobileMenuOpen,
  actionButton,
}: {
  mobileMenuOpen: boolean;
  setMobileMenuOpen: (isMobileMenuOpen: boolean) => void;
  actionButton: React.ReactNode;
}) {
  return (
    <Dialog
      as="div"
      className="lg:hidden"
      open={mobileMenuOpen}
      onClose={setMobileMenuOpen}
    >
      <div className="fixed inset-0 z-30" />
      <Dialog.Panel className="fixed inset-y-0 right-0 z-30 w-full overflow-y-auto bg-white p-4 sm:max-w-sm sm:ring-1 sm:ring-gray-900/10">
        <div className="flex items-center gap-x-6">
          <LogoLink className="-m-1.5 mr-auto p-1.5" />
          {actionButton}
          <button
            type="button"
            className="-m-2.5 rounded-md p-2.5 text-gray-700"
            onClick={() => setMobileMenuOpen(false)}
          >
            <span className="sr-only">Close menu</span>
            <XMarkIcon className="h-6 w-6" aria-hidden="true" />
          </button>
        </div>
        <div className="mt-6 flow-root">
          <div className="-my-6 divide-y divide-gray-500/10">
            <div className="space-y-2 py-6">
              {navigationMarketing.map((navItem) => (
                <div key={navItem.name} className="relative">
                  {navItem.external ?
                    <a
                      href={navItem.href}
                      className="-mx-3 block rounded-lg px-3 py-2 text-base font-semibold leading-7 text-gray-900 hover:bg-gray-50"
                      onClick={() => setMobileMenuOpen(false)}
                      target="_blank"
                    >
                      {navItem.name}
                      {navItem.label !== null && (
                        <Badge className="ml-2 bg-primaryLight text-gray-900 shadow-md">
                          {navItem.label}
                        </Badge>
                      )}
                    </a>
                  : <Link
                      href={navItem.href}
                      className="-mx-3 block rounded-lg px-3 py-2 text-base font-semibold leading-7 text-gray-900 hover:bg-gray-50"
                      onClick={() => setMobileMenuOpen(false)}
                    >
                      {navItem.name}
                      {navItem.label !== null && (
                        <Badge className="ml-2 bg-primaryLight text-gray-900 shadow-md">
                          {navItem.label}
                        </Badge>
                      )}
                    </Link>
                  }
                </div>
              ))}
            </div>
          </div>
        </div>
      </Dialog.Panel>
    </Dialog>
  );
}
